module.exports = __webpack_public_path__ + "static/media/del.ca62a2f2.svg";